<template>
  <b-overlay variant="success" opacity="0.5" :show="Esperar">
    <b-modal id="newUser">
      <template #modal-header> Nuevo Usuario </template>
      <b-form-group label="Usuario">
        <b-input autofocus v-model="nuevo.Nombre"></b-input>
      </b-form-group>
      <b-form-group label="Contraseña">
        <b-input v-model="nuevo.Pass"></b-input>
      </b-form-group>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('newUser')">Cerrar</b-button>
        <b-button variant="success" @click="Crear">Crear</b-button>
      </template>
    </b-modal>

    <b-modal id="CambioValor">
      <template #modal-header> Pago [{{ selConfig.id }}] </template>
      <b-form-group label="Valor">
        <b-input autofocus v-model="selConfig.valor"></b-input>
      </b-form-group>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('CambioValor')">Cerrar</b-button>
        <b-button variant="success" @click="Cambiar">Guardar</b-button>
      </template>
    </b-modal>

    <b-modal @show="newPass = ''" id="CambiarPass">
      <template #modal-header> Cambio de Contraseña </template>
      <b-form-group label="Valor">
        <b-input autofocus v-model="newPass"></b-input>
      </b-form-group>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('CambiarPass')">Cerrar</b-button>
        <b-button variant="success" @click="CambioClave">Guardar</b-button>
      </template>
    </b-modal>

    <b-tabs>
      <b-tab title="Parametros">
        <b-container class="mt-2">
          <b-row>
            <b-col> <h4>Parametros</h4></b-col>
          </b-row>
          <b-row>
            <b-table small striped bordered @row-clicked="onClick" :items="Configuracion"></b-table>
          </b-row>
        </b-container>
      </b-tab>
      
      <b-tab title="Repartidores">
        <Delivers />
      </b-tab>

      <b-tab title="Usuarios">
        <b-container class="mt-2">
          <b-row>
            <b-col> <h4>Usuarios</h4></b-col>
            <b-col class="gradiente text-center p-1">
              <b-button pill size="sm" variant="primary" v-b-modal.newUser> + <b-icon-person /> </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-table @row-clicked="CambioPass" small striped bordered :items="Datos" :fields="campos">
              <template #cell(Admin)="fila">
                <div class="text-center">
                  <b-form-checkbox @change="CambioPerfil(fila.item.Admin, fila.item.id)" v-model="fila.item.Admin"></b-form-checkbox>
                </div>
              </template>

              <template #cell(Opts)="row">
                <div class="opciones">
                  <b-button size="sm" pill variant="success" @click="CambioPass(row.item)"><b-icon-key-fill /></b-button>
                </div>
              </template>
            </b-table>
          </b-row>
        </b-container>
      </b-tab>

    </b-tabs>
  </b-overlay>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import Delivers from "./Delivers.vue";
const md5 = require("md5");

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  mounted() {
    this.Esperar = false;
  },
  methods: {
    CambioPerfil(valor, id) {
      this.Esperar = true;
      db.collection("Usuario")
        .doc(id)
        .update({ Admin: valor })
        .then(() => {
          this.Esperar = false;
        });
    },
    CambioClave() {
      if (!this.newPass == false) {
        this.Esperar = true;
        this.$bvModal.hide("CambiarPass");

        let nHash = md5(this.selUser.Nombre.toUpperCase() + this.newPass);

        db.collection("Usuario")
          .doc(this.selUser.id)
          .update({ Hash: nHash })
          .then(() => {
            this.Esperar = false;
            this.$bvModal.msgBoxOk("Contraseña actualizada!");
          });
      }
    },
    CambioPass(row) {
      this.selUser = { ...row };

      this.$bvModal.show("CambiarPass");
    },
    Crear() {
      this.Esperar = true;
      let usr = { ...this.nuevo };

      usr.Nombre = usr.Nombre.toLowerCase().trim();

      let existe = !!this.Usuarios.filter((u) => u.Nombre == usr.Nombre).length;

      if (!existe) {
        usr.Hash = md5(usr.Nombre.toUpperCase() + usr.Pass);
        usr.Creado = new Date();

        delete usr.Pass;

        db.collection("Usuario")
          .add(usr)
          .then(() => {
            this.Esperar = false;
          });
      } else {
        this.Esperar = false;
      }
    },
    Cambiar() {
      this.Esperar = true;
      this.$bvModal.hide("CambioValor");
      db.collection("Parametros")
        .doc(this.selConfig.id)
        .update({ valor: this.selConfig.valor })
        .then(() => {
          this.Esperar = false;
        });
    },
    onClick(row) {
      this.selConfig = { ...row };

      this.$bvModal.show("CambioValor");
    },
  },
  components: {
    Delivers,
  },
  computed: {
    Datos() {
      let datos = this.Usuarios.map((user) => {
        return {
          id: user.id,
          Nombre: user.Nombre,
          Admin: user.Admin,
          Ingreso: user.Ingreso ? user.Ingreso.toDate().toLocaleString("es-GT") : "",
          Url: user.URL,
        };
      });

      return datos;
    },
    Configuracion() {
      let parametros = this.Parametros.map((p) => {
        return { id: p.id, valor: p.valor };
      });

      return parametros;
    },
  },
  beforeCreate() {
    let aplica = this.$session.get("EsAdmin");
    if (!aplica) this.$router.push("/courier/home");
  },
  data() {
    return {
      campos: ["Nombre", "Admin", "Ingreso", "Url", "Opts"],
      selUser: null,
      newPass: null,
      nuevo: { Nombre: null, Pass: null },
      Parametros: [],
      Usuarios: [],
      selConfig: {},
      Esperar: true,
    };
  },
  firestore: {
    Usuarios: db.collection("Usuario"),
    Parametros: db.collection("Parametros"),
  },
};
</script>
<style scoped>
.gradiente {
  background-image: linear-gradient(to right, white, #e88a3f);
}
.opciones {
  width: 25px;
}
</style>
